<template>
    <div v-if="hasFieldToDisplay()">
        <div class="tabulation-title">
            <h5>
                <v-icon class="blue--text text--darken-2">label</v-icon>
                Informations spécifiques
            </h5>
        </div>

        <div class="form-container mr-auto ml-auto mt-5">
            <div v-for="familyElement in families">
                <v-expansion-panels class="mb-5" v-if="getField(familyElement.name) !== undefined &&
                getField(familyElement.name).title !== null">
                    <v-expansion-panel>
                        <v-expansion-panel-header>
                            <b style="color: #697db5">{{ getField(familyElement.name).title }}</b>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <div v-html="getField(familyElement.name).description"></div>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>

                <v-autocomplete v-if="hasFamilyElement(familyElement.name) &&
                (providerFamilies[familyElement.name].length > 0 || !getField(familyElement.name).skipped)"
                                :items="getFamilyByCode(familyElement.name)"
                                chips
                                @change="updateOrDeleteElement($event, familyElement.name)"
                                :value="providerFamilies[familyElement.name]"
                                deletable-chips
                                :label="familyElement.label"
                                item-text="label"
                                return-object
                                :class="{'input-error': hasForbiddenElement(providerFamilies[familyElement.name])}"
                                :multiple="!familyElement.multiplicity"
                                outlined
                                :disabled="readOnly">
                </v-autocomplete>

                <v-autocomplete v-if="hasFamilyElement(familyElement.name) &&
                providerFamilies[familyElement.name].length === 0 && getField(familyElement.name).skipped"
                                :items="['Non concerné']"
                                chips
                                :label="familyElement.label"
                                :value="'Non concerné'"
                                outlined
                                :diasbled="readOnly">
                </v-autocomplete>

                <div v-if="getField(familyElement.name) !== undefined &&
                getField(familyElement.name).title !== null" style="height: 40px"></div>
            </div>

            <v-text-field v-if="hasField('AGREMENT_NUMBER')"
                          label="N° d'agrément ou de référencement"
                          v-model="agrementNumber"
                          @change="updateAgrementNumber"
                          outlined>
            </v-text-field>

            <div v-if="hasField('CHIEF')">
                <v-text-field style="padding-top: 0 !important;"
                              v-model="chef"
                              @change="updateChef"
                              outlined
                              label="Chef"
                              :disabled="readOnly">
                </v-text-field>
            </div>

            <v-text-field v-if="hasField('MIN_AGE')"
                          label="Age minimum (en années)"
                          v-model="minAge"
                          @change="updateNumericFields([$event, 'MIN_AGE'])" type="number"
                          outlined>
            </v-text-field>

            <v-text-field v-if="hasField('MAX_AGE')"
                          label="Age maximum (en années)"
                          v-model="maxAge"
                          @change="updateNumericFields([$event, 'MAX_AGE'])" type="number"
                          outlined>
            </v-text-field>

            <v-text-field v-if="hasField('MAX_GROUP_SIZE')"
                          label="Taille groupe max (en personnes)"
                          v-model="maxGroupSize"
                          @change="updateNumericFields([$event, 'MAX_GROUP_SIZE'])" type="number"
                          outlined>
            </v-text-field>

            <v-text-field v-if="hasField('MIN_GROUP_SIZE')"
                          label="Nombre de personnes minimum"
                          v-model="minGroupSize"
                          @change="updateNumericFields([$event, 'MIN_GROUP_SIZE'])" type="number"
                          outlined>
            </v-text-field>

            <div v-if="hasField('DATE_CLASSEMENT_HLO') &&
            (hloRankingDate !== null || !getField('DATE_CLASSEMENT_HLO').skipped)">
                <v-text-field
                  readonly
                  style="padding-top: 0 !important;"
                  v-model="hloRankingDate"
                  label="Classement Atout France"
                  @click="showPicker = true"
                  outlined
                  :disabled="readOnly">
                </v-text-field>
            </div>

            <div v-else-if="hasField('DATE_CLASSEMENT_HLO') && hloRankingDate === null &&
            getField('DATE_CLASSEMENT_HLO').skipped">
                <v-text-field
                  readonly
                  style="padding-top: 0 !important;"
                  value="Non concerné"
                  outlined
                  label="Classement Atout France">
                </v-text-field>
            </div>

            <div v-if="hasField('COMPLEMENT_ACCUEIL')">
                <v-textarea
                  class="textarea"
                  :value="complementAccueil"
                  @change="updateComplementAccueil"
                  outlined
                  label="Complément accueil"
                  :disabled="readOnly">
                </v-textarea>
            </div>

            <div v-if="hasField('CITQ_NUMBER')">
                <v-text-field
                  class="textarea"
                  :value="citqNumber"
                  @change="updateCitqNumber"
                  outlined
                  label="Numéro CITQ"
                  :disabled="readOnly">
                </v-text-field>
            </div>

            <div v-if="hasField('QUEBEC_CAPACITY_TOTAL_FR')">
                <v-textarea
                  class="textarea"
                  :value="quebecTotalCapacityFr"
                  @change="updateQuebecTotalCapacityFr"
                  outlined
                  label="Capacité d'accueil"
                  :disabled="readOnly">
                </v-textarea>
            </div>

            <div v-if="hasField('QUEBEC_CAPACITY_TOTAL_EN')">
                <v-textarea
                  class="textarea"
                  :value="quebecTotalCapacityEn"
                  @change="updateQuebecTotalCapacityEn"
                  outlined
                  label="Capacité d'accueil (EN)"
                  :disabled="readOnly">
                </v-textarea>
            </div>

            <div v-if="hasField('ACCEPTED_ANIMALS')" style="margin-bottom: 30px">
                <label>Animaux acceptés</label>
                <v-radio-group
                  row
                  class="mt-auto mb-auto"
                  :value="acceptedAnimals"
                  @change="updateBooleanElement([$event, 'ACCEPTED_ANIMALS'])"
                  style="padding-top: 0 !important;"
                  :disabled="readOnly">
                    <v-radio label="Oui" class="text" :value="true"></v-radio>
                    <v-radio label="Non" class="text" :value="false"></v-radio>
                    <v-radio label="Non communiqué" class="text" value="null"></v-radio>
                </v-radio-group>
            </div>

            <v-textarea v-if="hasField('DESC_ANIMALS_WELCOME')"
                          label="Conditions d’accueil des animaux"
                          v-model="animalsWelcome"
                          @change="updateAnimalsWelcome"
                          outlined>
            </v-textarea>
        </div>

        <v-dialog ref="dialog" v-model="showPicker" width="290px">
            <v-date-picker
              locale="fr-FR"
              color="primary"
              v-model="selectedDate"
              @input="setDatePicker"
              :first-day-of-week="1">
                <v-spacer></v-spacer>
            </v-date-picker>
        </v-dialog>
    </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex"

export default {
    name: "Specific",
    props: ["readOnly"],
    data() {
        return {
            providerFamilies: {},
            familyToEscape: ["OfferType", "Capacites"],
            families: [],
            acceptedAnimals: null,
            showPicker: false,
            selectedDate: null,
            hloRankingDate: null,
            minAge: null,
            maxAge: null,
            maxGroupSize: null,
            minGroupSize: null,
        }
    },
    methods: {
        ...mapMutations("web_form", [
            "addElement", "removeElement", "updateBooleanElement", "pushBooleanElement", "updateForbiddenThematisedDesc",
          'updateNumericFields', 'pushNumericField',
        ]),
        hasFieldToDisplay() {
            let has = false

            this.families.forEach(family => {
                if (this.hasFamilyElement(family.name)) {
                    has = true
                }
            })

            if (this.hasField("CHIEF")) {
                has = true
            }

            if (this.hasField("COMPLEMENT_ACCUEIL")) {
                has = true
            }

            if (this.hasField("ACCEPTED_ANIMALS")) {
                has = true
            }

            if (this.hasField("CITQ_NUMBER")) {
                has = true
            }

            if (this.hasField("QUEBEC_CAPACITY_TOTAL_FR") || this.hasField("QUEBEC_CAPACITY_TOTAL_EN")) {
                has = true
            }

            if (this.hasField("MIN_AGE")) {
                has = true
            }

            if (this.hasField("MAX_AGE")) {
                has = true
            }

            if (this.hasField("MAX_GROUP_SIZE")) {
                has = true
            }

            if (this.hasField("MIN_GROUP_SIZE")) {
                has = true
            }

            if (this.hasField("AGREMENT_NUMBER")) {
                has = true
            }

            if (this.hasField("DESC_ANIMALS_WELCOME")) {
                has = true
            }

            return has
        },
        updateOrDeleteElement(newElements, property) {
            let currentElements = this.providerFamilies[property]

            if (newElements === null) {
                newElements = {}
                this.emptyField(currentElements)
            } else if (currentElements.length > newElements.length) {  // Cas suppression
                this.deleteElement(currentElements, newElements)
            } else { // Cas Ajout
                this.addNewElement(currentElements, newElements)
            }

            this.providerFamilies[property] = newElements
            this.updateForbiddenThematisedDesc()
        },
        addNewElement(currentElements, newElements) {
            let element = newElements
            const previousValue = JSON.parse(JSON.stringify(currentElements))

            if (Array.isArray(newElements)) {
                let diff = newElements.filter(_element => !previousValue.includes(_element)) || []

                if (diff.length) {
                    element = diff[diff.length - 1]
                }
            } else if (previousValue) {
                this.removeElement(previousValue)
            }

            this.addElement(element)
        },
        deleteElement(currentElements, newElements) {
            const previousValue = JSON.parse(JSON.stringify(currentElements))

            const diff = previousValue.filter(element => {
                return !newElements.map(elt => elt.id).includes(element.id)
            }) || []

            let element = newElements

            if (diff.length) {
                element = diff[diff.length - 1]
            }

            this.removeElement(element)
        },
        emptyField(currentElements) {
            const previousValue = JSON.parse(JSON.stringify(currentElements))

            this.removeElement(previousValue)
        },
        setHloRankingDate() {
            if (this.provider.date_fields !== undefined && this.provider.date_fields.length) {
                this.provider.date_fields.forEach(field => {
                    if (field.code === "DATE_CLASSEMENT_HLO") {
                        this.hloRankingDate = this.formatDate(field.value, false)
                    }
                })
            }
        },
        setDatePicker(value) {
            this.hloRankingDate = this.formatDate(value, false)

            this.provider.date_fields.forEach(field => {
                if (field.code === "DATE_CLASSEMENT_HLO") {
                    field.value = this.formatDate(value, false)
                }
            })
        },
        updateComplementAccueil(value) {
            this.provider.contents.forEach(content => {
                if (content.language.code === "fr") {
                    content.complement_accueil = value
                }
            })
        },
        updateChef(value) {
            this.provider.contents.forEach(content => {
                if (content.language.code === "fr") {
                    content.chef = value
                }
            })
        },
        updateCitqNumber(value) {
            this.provider.contents.forEach(content => {
                if (content.language.code === "fr") {
                    content.citq_number = value
                }
            })
        },
        updateQuebecTotalCapacityFr(value) {
            this.provider.contents.forEach(content => {
                if (content.language.code === "fr") {
                    content.quebec_total_capacity = value
                }
            })
        },
        updateQuebecTotalCapacityEn(value) {
            this.provider.contents.forEach(content => {
                if (content.language.code === "en") {
                    content.quebec_total_capacity = value
                }
            })
        },
        updateAgrementNumber(value) {
            this.provider.contents.forEach(content => {
                if (content.language.code === "fr") {
                    content.agrement_number = value
                }
            })
        },
        updateAnimalsWelcome(value) {
            this.provider.contents.forEach(content => {
                if (content.language.code === "fr") {
                    content.description_animals_welcome = value
                }
            })
        },
        hasForbiddenElement(elements) {
            if (this.forbiddenElements.length > 0) {
                let hasForbiddenElement = false
                if (elements.length !== undefined && elements.length > 0) {
                    elements.forEach(el => {
                        if (this.forbiddenElements.includes(el.apidae_element_id)) {
                            hasForbiddenElement = true
                        }
                    })
                } else if (elements.length === undefined && elements.apidae_element_id) {
                    if (this.forbiddenElements.includes(elements.apidae_element_id)) {
                        hasForbiddenElement = true
                    }
                }
                return hasForbiddenElement
            }
        },
        setNumericField() {
            if (this.provider.numeric_fields !== null && this.provider.numeric_fields !== undefined) {
                let foundAgeMin = false
                let foundAgeMax = false
                let foundMaxGroupSize = false
                let foundMinGroupSize = false

                this.provider.numeric_fields.forEach(numericField => {
                    if (numericField.attribute.code === 'MIN_AGE') {
                        this.minAge = numericField.value

                        foundAgeMin = true
                    }

                    if (numericField.attribute.code === 'MAX_AGE') {
                        this.maxAge = numericField.value

                        foundAgeMax = true
                    }

                    if (numericField.attribute.code === 'MAX_GROUP_SIZE') {
                        this.maxGroupSize = numericField.value

                        foundMaxGroupSize = true
                    }

                    if (numericField.attribute.code === 'MIN_GROUP_SIZE') {
                        this.minGroupSize = numericField.value

                        foundMinGroupSize = true
                    }
                })

                if(!foundAgeMin) {
                    let numericField = {
                        attribute: {
                            code: 'MIN_AGE'
                        },
                        value: null
                    }
                    this.pushNumericField(numericField)
                }

                if(!foundAgeMax) {
                    let numericField = {
                        attribute: {
                            code: 'MAX_AGE'
                        },
                        value: null
                    }
                    this.pushNumericField(numericField)
                }

                if(!foundMaxGroupSize) {
                    let numericField = {
                        attribute: {
                            code: 'MAX_GROUP_SIZE'
                        },
                        value: null
                    }
                    this.pushNumericField(numericField)
                }

                if(!foundMinGroupSize) {
                    let numericField = {
                        attribute: {
                            code: 'MIN_GROUP_SIZE'
                        },
                        value: null
                    }
                    this.pushNumericField(numericField)
                }
            }
        },
    },
    computed: {
        ...mapState("web_form", ["provider", "disabled", "familyElements", "categoryFamilies", "forbiddenThematisedDesc",
            "forbiddenElements"]),
        ...mapGetters("web_form", ["hasField", "hasFamilyElement", "getFamilyByCode", "getElementsByFamilyCode", "getField"]),
        complementAccueil() {
            let _content = {}

            this.provider.contents.forEach(content => {
                if (content.language.code === "fr") {
                    _content = content
                }
            })

            return _content.complement_accueil
        },
        chef() {
            let _content = {}

            this.provider.contents.forEach(content => {
                if (content.language.code === "fr") {
                    _content = content
                }
            })

            return _content.chef
        },
        citqNumber() {
            let _content = {}

            this.provider.contents.forEach(content => {
                if (content.language.code === "fr") {
                    _content = content
                }
            })

            return _content.citq_number
        },
        quebecTotalCapacityFr() {
            let _content = {}

            this.provider.contents.forEach(content => {
                if (content.language.code === "fr") {
                    _content = content
                }
            })

            return _content.quebec_total_capacity
        },
        quebecTotalCapacityEn() {
            let _content = {}

            this.provider.contents.forEach(content => {
                if (content.language.code === "en") {
                    _content = content
                }
            })

            return _content.quebec_total_capacity
        },
        agrementNumber() {
            let _content = {}

            this.provider.contents.forEach(content => {
                if (content.language.code === "fr") {
                    _content = content
                }
            })

            return _content.agrement_number
        },
        animalsWelcome() {
            let _content = {}

            this.provider.contents.forEach(content => {
                if (content.language.code === "fr") {
                    _content = content
                }
            })

            return _content.description_animals_welcome
        },
    },
    created() {
        this.acceptedAnimals = String(null)

        this.families = this.categoryFamilies.filter(family => !this.familyToEscape.includes(family.name))

        this.families.forEach(family => {
            this.$set(this.providerFamilies, family.name, this.getElementsByFamilyCode(family.name, family.multiplicity))
        })

        this.setHloRankingDate()
        this.setNumericField()

        if (this.provider.boolean_elements !== null && this.provider.boolean_elements !== undefined) {
            let foundAcceptedAnimals = false

            this.provider.boolean_elements.forEach(booleanElement => {
                if (booleanElement.attribute.code === "ACCEPTED_ANIMALS") {
                    this.acceptedAnimals = booleanElement.value ?? String(booleanElement.value)

                    foundAcceptedAnimals = true
                }
            })

            if (!foundAcceptedAnimals) {
                let booleanElement = {
                    attribute: {
                        code: "ACCEPTED_ANIMALS",
                    },
                    value: "null",
                }
                this.pushBooleanElement(booleanElement)
            }
        }
    },
}
</script>